import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <h1 className="font-display text-4xl">Reset your password</h1>
      {sent ? (
        <p className="mt-4 text-neutral-700">If that email is registered, a reset link has been sent. Check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input required type="email" placeholder="Registered email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-4 py-3 rounded-lg border"/>
          <button className="btn-wine w-full justify-center">Send reset link</button>
        </form>
      )}
      <div className="mt-6 text-sm"><Link to="/login" className="text-[color:var(--wine)] underline">Back to sign in</Link></div>
    </div>
  );
}
